<template>
  <div class="app-single-topup-bank-transfer">
    <slot name="txtBefore">
      <h2>Einmaliges Aufladen</h2>
      <p>Bitte überweisen Sie den gewünschten Betrag unter Angabe Ihrer Kundennummer auf nachfolgendes Konto</p>
    </slot>

    <dyn-slot :slot-data="slotData">
      <slot name="txtTransfer">
        Kontoinhaber: Musterinhaber<br/>
        IBAN: Muster-IBAN<br/>
        BIC: Muster-BIC<br/>
        Name der Bank: Musterbank<br/>
        Verwendungszweck: {{slotData.customerId}}
      </slot>
    </dyn-slot>

    <slot name="txtAdditional">
      <p>Wichtiger Hinweis: hier stehen zusätzliche Informationen zur Überweisung.</p>
    </slot>

    <Stepper
      :show-next="false"
      @prev="prev()"
    >
      <template #btnPrev><slot name="btnPrev"></slot></template>
      <template #btnNext><slot name="btnNext"></slot></template>
    </Stepper>
    <slot name="textAfter"></slot>
  </div>
</template>

<script>
import Stepper from '../../../../generic/Stepper.vue'
import processSteps from '../../../../../mixins/processSteps'
import { stepName as previousStep } from './AmountSelector.vue'
import { mapMutations } from 'vuex'
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'

export const stepName = 'bankTransfer'

export default {
  name: 'SingleTopUpBankTransfer',
  components: { Stepper },
  mixins: [
    processSteps(stepName, previousStep, stepName)
  ],
  data () {
    return {
      currentCustomer: {
        customerId: '',
        contract: {
          contractId: ''
        }
      }
    }
  },
  computed: {
    slotData: function () {
      return {
        customerId: this.currentCustomer.customerId,
        contractId: this.currentCustomer.contract.contractId
      }
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query singleTopUp {
          currentCustomer {
            customerId
            contract {
              contractId
            }
          }
        }`, this, 'currentCustomer'
      )
    }
  },
  methods: {
    ...mapMutations('topUp/single', [
      'changeStep'
    ]),
    prev () {
      this.changeStep({ step: this.previousStep })
    }
  }
}
</script>
